export const FONTS = {
  regular: "Sora",
  bold: "Sora",
  regularInter: "Inter",
  boldInter: "Inter",
};
